import { createContext, useContext } from 'react';
import { BaggageValue, SettableBaggageKey } from '../baggageKeys';

/**
 * What a data owner reports to telemetry. Providers call setTelemetryBaggage during their
 * render body with current values, which lands them before any child fires a request.
 *
 * Kept separate from TelemetryProvider on purpose: this file imports React and nothing else,
 * so app providers can consume it without pulling the route tree (and therefore most of the
 * app) into their module graph. Merging the two creates an import cycle -- see useTelemetry.ts.
 */
export interface TelemetryApi {
  setTelemetryBaggage: (key: SettableBaggageKey, value: BaggageValue) => void;
}

/** No-op default so a provider rendered outside TelemetryProvider reports nothing, not throws. */
const NO_OP_TELEMETRY: TelemetryApi = {
  setTelemetryBaggage: () => undefined,
};

export const TelemetryContext = createContext<TelemetryApi>(NO_OP_TELEMETRY);

/** Access the telemetry reporting API. Returns no-ops when no TelemetryProvider is mounted. */
export function useTelemetry(): TelemetryApi {
  return useContext(TelemetryContext);
}
